import RetoolComp from '../retool_components/retool';

export const Reporting = () => {
  const reporting_uuid = 'e9514074-6858-11ee-9850-772a7f9b3fec';
  return <RetoolComp component_uuid={reporting_uuid} />;
};
